import { render, staticRenderFns } from "./w-grid.vue?vue&type=template&id=be31d5a6"
import script from "./w-grid.vue?vue&type=script&lang=js"
export * from "./w-grid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports